import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitStatus('success');
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9q543snlsngrm4llrng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = { code: 'Unknown' }; }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试');
      }
    } catch {
      setSubmitStatus('error');
      setErrorMsg('网络异常，请稍后重试');
    }
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-xl text-white mb-4">愽彩糖果</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                缤纷糖果在线选购平台，汇聚海量缤纷糖果，提供多口味、多品类糖果在线选购服务，一站满足您的所有甜蜜需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">糖果分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors">首页</Link></li>
                <li><Link to="/articles" className="text-sm text-background-400 hover:text-accent-400 transition-colors">糖果资讯</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors">关于我们</Link></li>
                <li><Link to="/category/bulk-candy" className="text-sm text-background-400 hover:text-accent-400 transition-colors">散装糖果批发</Link></li>
                <li><Link to="/category/gift-box" className="text-sm text-background-400 hover:text-accent-400 transition-colors">糖果礼盒</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">订阅优惠资讯</h4>
              <p className="text-sm text-background-400 mb-4">订阅即可获取最新糖果上架信息和专属优惠</p>
              <form onSubmit={handleSubscribe} data-readdy-form="">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="请输入邮箱地址"
                    required
                    className="flex-1 px-4 py-2.5 rounded-lg text-sm bg-background-800 text-white placeholder:text-background-500 border border-background-700 focus:outline-none focus:border-accent-500 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-5 py-2.5 rounded-lg text-sm font-medium bg-accent-500 text-background-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </div>
                {submitStatus === 'success' && (
                  <p className="text-sm text-green-400 mt-2">订阅成功！感谢您的关注</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-sm text-red-400 mt-2">{errorMsg}</p>
                )}
              </form>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 愽彩糖果. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-accent-400 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-accent-400 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-accent-400 transition-colors" aria-label="小红书">
                <i className="ri-share-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}